import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetctHostProfile } from "src/actions/EditHost";
import { fetchUnreadTotal } from "src/utils/chat";
import { realtime } from "src/utils/realtime";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";

const DashboardLayout = () => {
  const dispatch = useDispatch();
  const host = useSelector((state) => state.edit_host?.host);
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState(0);

  useEffect(() => {
    if (!host) dispatch(fetctHostProfile());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Unread chat messages for the sidebar badge, kept live over the websocket.
  useEffect(() => {
    fetchUnreadTotal()
      .then(setUnreadMessages)
      .catch(() => {});
    const release = realtime.retain();
    const off = realtime.on("chat.conversation", ({ unread_total: total }) => {
      if (typeof total === "number") setUnreadMessages(total);
    });
    return () => {
      off();
      release();
    };
  }, []);

  return (
    <div className="hd-layout">
      <DashboardSidebar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
        unreadMessages={unreadMessages}
      />
      <div className="hd-main">
        <DashboardNavbar onMobileNavOpen={() => setMobileNavOpen(true)} />
        <main className="hd-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
